import {Component, ViewEncapsulation} from '@angular/core';
import {LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';
import {ApiService} from 'src/app/shared/services/api.service';
import {QrService} from 'src/app/shared/services/qr.service';
import {InactivityService} from 'src/app/shared/services/inactivity.service';
import {RequestService} from 'src/app/shared/services/request.service';
import {PaymentReason} from 'src/app/shared/models/request';

declare const window: Window & {initialQueryString: string[][]};

@Component({
  selector: 'app-success-payment',
  templateUrl: './success-payment.component.html',
  styleUrls: ['./success-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SuccessPaymentComponent {

  isPaymentError: string;
  longError: PaymentReason | string;

  constructor(public nav: NavigateService,
              public cart: CartService,
              public api: ApiService,
              public loader: LoaderService,
              public qr: QrService,
              private inactivity: InactivityService,
              public request: RequestService,
              private lang: LangService) {
    const errorHolder = window.initialQueryString.find((q: string[]) => q[0] === 'error');
    if(errorHolder) {
      this.isPaymentError = errorHolder[1];
    }
    const longErrorHolder = window.initialQueryString.find((q: string[]) => q[0] === 'longError');
    if(errorHolder && longErrorHolder) {
      this.longError = this.determineError(decodeURIComponent(longErrorHolder[1]));
      this.request.cleanupError(this.cart.currentApplication.isExtend, 'SuccessPayment cleanup because of error: '+ errorHolder[1]);
    }
    if(!this.isPaymentError && this.api.env.useGuichet) {
      this.cart.deleteSavedApplication();
    }
    if(this.inactivity.isWatching) this.inactivity.stopWatching();
  }

  ngOnDestroy() {
    if(this.isPaymentError) {
      window.initialQueryString = [];
    } else if(!this.api.env.useGuichet) {
      this.cart.deleteSavedApplication();
    }
    this.inactivity.stopWatching();
  }

  navClose() {
    if(this.isPaymentError) {
      this.nav.to('summary');
    } else {
      this.nav.to('trips');
    }
  }

  determineError(error: string): PaymentReason | string {
    if(error.includes('cancelled')) {
      return PaymentReason.CANCELLED;
    } else if(error.includes('Invalid card number') || error.includes('Invalid PAN')) {
      return PaymentReason.INVALID_CARD_NUMBER;
    } else if(error.includes('Unsupported association')) {
      return PaymentReason.UNKNOW_ERROR;
    }
    return error;
  }

  getLongError(): string {
    if(typeof this.longError === 'string' && PaymentReason[this.longError as keyof typeof PaymentReason]) {
      return this.lang.transform('DYN.' + this.longError);
    }
    return this.longError;
  }
}
